mutation updateWidgetType($input: UpdateWidgetTypeInput!) {
  cmsOrganization: updateWidgetType(input: $input) {
    id
    widgetType
  }
}
